// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"_J-z","carouselContainer":"aK-z"};